import Joi from "joi";
import { circleBg, facebookIcon, googleIcon, stepsBg } from "../../constants/images";
import { useDictionary } from "../../contexts/dictionary";
import { BoxContainer, Col, HeroBanner, List, ListItem, Row, Text, Title, VerticalSeparator, VImage } from "../../style/base.style";
import { Colors } from "../../style/colors";



import { useNavigate } from "react-router-dom";
import { useDeviceType } from "../../contexts/DeviceContext";

import { plans } from "../../assets/constant/plans";

import { useEffect, useState } from "react";

import { useContactType } from "../../contexts/ContactContext";
import { routesMap } from "../../constants/routes";
import { CheckoutLayout } from "../../components/checkout/CheckoutLayout";
import { RegistrationComponent } from "../../components/authentication/registration";


export const CheckoutRegistrationPage = () => {

  
     const {translate} = useDictionary()
     const {isMobile} = useDeviceType()
     const {cart,contact} = useContactType()

     const productId = cart[0]?.product
     const navigate = useNavigate()
     
    
    
     useEffect(() => {
      if(!productId){
        navigate(routesMap.checkoutChoosePlan.to)
      } else if (contact){
        navigate(routesMap.checkoutAddtionalInfo.to)
      }
     },[])



     const productData = plans.find((item) => item.crmProductId === productId)
     const description = "you_have_chosen"
  

  
    
    return (
        
        <CheckoutLayout page="register">
              <Row $width="100%" $justifyContent="space-between" $alignItems="flex-start" $padding="20px 0" $gap={20}>
              <BoxContainer $width={isMobile?"100%":"50%"}>
              <Col $width={isMobile?"100%":"100%"} $alignItems={isMobile?"center":"flex-start"} >
                <Text $color={Colors.text} $fontSize={'20px'}>{translate(description || "membership_title")}</Text>
                <Title $color={Colors.primary} $fontSize={36} $margin="0px 0">{translate(productData?.name || "")}</Title>
                           
                           <Col $width="100%" $alignItems="flex-start" $justifyContent="flex-start" $padding="20px 0">
                           <List>
                             {
                               productData?.benefits?.map((item, index) => {
                                if(index > 10) return null
                                 return (
                                   <ListItem $color={Colors.text} $fontSize={20} key={index}>{translate(item)}</ListItem>
                                 )
                               })
                               
                             }
                             <ListItem $color={Colors.text} $fontSize={20} key={"more"}>{translate("and_more")}</ListItem>
                             
                           </List>
                           </Col>
               
                           
                </Col>
              </BoxContainer>
                
                <RegistrationComponent nextPage="/checkout"/>
            </Row>
        </CheckoutLayout>

   
    )
};